import { Stack, SvgIcon, useTheme } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

import useEmblaCarousel, { UseEmblaCarouselType } from 'embla-carousel-react';
import Thumb from './thumb';
import { isVideo } from '../../utils/is-video';
import { playIcon } from '../../config/icons';

type Props = {
  urls: string[];
  mainImageUrl?: string;
  emblaMainApi?: UseEmblaCarouselType[1];
};

export const Thumbnails = ({ urls, mainImageUrl, emblaMainApi }: Props) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const direction = useTheme().direction;
  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    dragFree: true,
    containScroll: 'keepSnaps',
    startIndex: 0,
    align: 'center',
    direction,
  });

  const onSelect = useCallback(() => {
    if (!emblaMainApi || !emblaThumbsApi) return;
    const index = emblaMainApi.selectedScrollSnap();
    setSelectedIndex(index);
    emblaThumbsApi.scrollTo(index, true);
  }, [emblaMainApi, emblaThumbsApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaMainApi) return;
    onSelect();

    emblaMainApi.on('select', onSelect).on('reInit', onSelect);
  }, [emblaMainApi, onSelect]);

  const handleClick = useCallback(
    (index: number) => {
      emblaMainApi?.scrollTo(index);
    },
    [emblaMainApi],
  );

  return (
    <>
      {urls.length > 1 && (
        <div ref={emblaThumbsRef} style={{ overflow: 'hidden', margin: 'auto', maxWidth: '100%' }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              margin: '0',
              padding: '0',
            }}
          >
            {urls.map((url, index) => {
              const isActive = selectedIndex === index;

              return isVideo(url) ? (
                <div
                  key={index}
                  onClick={() => handleClick(index)}
                  style={{ position: 'relative', display: 'inline-flex' }}
                >
                  <Thumb
                    src={mainImageUrl || urls[1] || url}
                    onClick={() => handleClick(index)}
                    isActive={isActive}
                    size={50}
                  />
                  <SvgIcon
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      zIndex: 1,
                      color: 'white',
                    }}
                  >
                    {playIcon}
                  </SvgIcon>
                </div>
              ) : (
                <Thumb
                  key={index}
                  src={url}
                  onClick={() => handleClick(index)}
                  isActive={isActive}
                  size={50}
                />
              );
            })}
          </Stack>
        </div>
      )}
    </>
  );
};
